import events from 'events.js';

(async function () {
    await events.ready();

    // Remove hide class, needs to happen before measuring elements
    // so we get the right sizes
    document.getElementById('hs_widget').removeAttribute('class');

    const contentWidth = window.innerWidth - 6;
    const contentDivHeight = window.innerHeight;
    const headerDivHeight = document.getElementById('hs_widget_head')
        .offsetHeight;
    const footerDivHeight = document.getElementById('hs_widget_footer')
        .offsetHeight;
    const listHeight = document.getElementById('results').offsetHeight;
    const next = document.getElementsByClassName('next')[0];
    const nextHeight = next ? next.offsetHeight : 0;

    const anchorsHeight = headerDivHeight + footerDivHeight;
    const feedHeight = contentDivHeight - anchorsHeight - 6;
    const scrollHeight = feedHeight - nextHeight;

    if (feedHeight > listHeight) {
        document.getElementById('results').style.height = `${scrollHeight}px`;
    }

    document.getElementById('hs_widget_feed').style.height = `${feedHeight}px`;
    document.getElementById('hs_widget').style.width = `${contentWidth}px`;
})();
